import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appValidationBorder]',
  standalone: true
})
export class ValidationBorderDirective implements OnChanges {
  @Input() appValidationBorder: unknown = null;
  @Input() validationBorderRequired: boolean = true;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appValidationBorder'] || changes['validationBorderRequired']) {
      this.updateBorder();
    }
  }

  private updateBorder(): void {
    const hasValue = this.hasValue(this.appValidationBorder);
    const borderColor = hasValue ? '#52c41a' : this.validationBorderRequired ? '#ff4d4f' : '#faad14';

    this.renderer.setStyle(this.el.nativeElement, 'display', 'block');
    this.renderer.setStyle(this.el.nativeElement, 'border', `1px solid ${borderColor}`);
    this.renderer.setStyle(this.el.nativeElement, 'border-radius', '6px');
    this.renderer.setStyle(this.el.nativeElement, 'padding', '2px');
    this.renderer.setStyle(this.el.nativeElement, 'transition', 'border-color 0.2s ease');
  }

  private hasValue(value: unknown): boolean {
    if (Array.isArray(value)) {
      return value.some(item => this.hasValue(item));
    }

    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'number') {
      return value > 0;
    }

    if (typeof value === 'string') {
      return value.trim().length > 0;
    }

    return value !== null && value !== undefined;
  }
}
